<template>
<div id="aha-infokontakt">
  <section id="archiv" v-if="archive.children.length > 0" class="no-pad">
    <h1 class="no-pad" v-html="archive.title"></h1>
    <ul class="aha-archive">
      <li v-for="year in archive.children" :key="year.id"><a :href="year.link">{{year.title}}</a></li>
    </ul>
  </section>

  <section id="kontakt" class="no-pad">
    <h1 class="no-pad" v-html="info.title"></h1>
    <p class="aha-location" v-html="info.location_text"></p>
  </section>

  <section id="organisation" class="no-pad">
    <h1 class="no-pad">Organisation</h1>
    <organiser :post="organiser" v-for="organiser in info.children" :key="organiser.uid"></organiser>
  </section>

  <!-- <section id="anfahrt">
      <h1 class="no-pad" v-if="this.$route.name !== 'english'">Anfahrt</h1>
      <h1 class="no-pad" v-else>Directions</h1>
      <div class="aha-directions" v-html="info.directions_text">
      </div>
    </section> -->

  <section id="support" class="no-pad">
    <h1 class="no-pad">Support</h1>
    <ul class="aha-archive">
      <li v-if="this.$route.name !== 'english'">
        Dir gefällt, was wir machen? Unterstütze uns!<br>
        <br>
        Kontoinhaber: aha Festival<br>
        IBAN: CH84 0077 8207 9140 5200 1<br>
        Vermerk: «Spende»<br>
        BIC: LUKBCH2260A<br>
        SWIFT: LUKBCH2260A<br>
        <br>
        Vielen lieben Dank!
      </li>
      <li v-else>
        You like what we're doing? Support us! <br>
        <br>
        Account holder: aha Festival<br>
        IBAN: CH84 0077 8207 9140 5200 1<br>
        Note: «Donation»<br>
        BIC: LUKBCH2260A<br>
        SWIFT: LUKBCH2260A<br>
        <br>
        Thank you very much!
      </li>
    </ul>
  </section>

  <section id="credits" class="no-pad">
    <p class="aha-location" v-html="info.credits_text">
    </p>
  </section>
</div>
</template>

<script>
import Organiser from '../components/Organiser.vue'

export default {
  name: 'kontakt',
  components: {
    Organiser
  },
  computed: {
    info() {
      return this.$store.getters.getPageByUID('kontakt')
    },
    festival() {
      return this.$store.getters.getPageByUID('festival')
    },
    archive() {
      return this.$store.getters.getPageByUID('archiv')
    }
  },
  data() {
    return {}
  }
}
</script>

<style lang="scss">
@import '../assets/styles/base';
.aha-location {
    // padding-top: $gap / 2;
}
.aha-archive,
.aha-directions,
.aha-location {
    li {
        padding: $gap / 2 0;
        width: 100%;
        margin-bottom: 0;
        border-bottom: 2px solid $font-color;
        @media only screen and (max-width: $phone) {
            border-bottom: 1px solid $font-color;
        }
    }
}

#credits {
    .aha-location {
        font-size: $font-size / 3;
        line-height: 1.25;
    }
}
</style>
